import React from "react";

import { Breadcrumbs } from "components";
import { SplitProfileForm } from "components/pages/residualsSplitProfile/splitProfileForm/index";
import { AddSplitProfileProps } from "types";

export const AddSplitProfile = ({
	loading,
	isAgentDataLoading,
	breadcrumb,
	submit,
	agent,
}: AddSplitProfileProps) => {
	return (
		<div className="page-content-wrapper">
			<Breadcrumbs pages={breadcrumb} />
			<SplitProfileForm
				submit={submit}
				loading={loading}
				isAgentDataLoading={isAgentDataLoading}
				isEditing={false}
				agent={agent}
			/>
		</div>
	);
};
